import React, { useState } from "react";
import JSONPretty from "react-json-pretty";
import "react-json-pretty/themes/monikai.css"; // Optional: JSON styling theme
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const HowToSchemaForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    totalTime: "",
    estimatedCost: "",
    currency: "USD",
    imageUrl: "",
    supplies: [],
    tools: [],
    steps: [],
  });

  const [schema, setSchema] = useState({
    "@context": "https://schema.org",
    "@type": "HowTo",
    name: "Example How-To",
    description: "This is an example description.",
    totalTime: "PT1H",
    estimatedCost: {
      "@type": "MonetaryAmount",
      currency: "USD",
      value: "10",
    },
    image: "https://example.com/image.jpg",
    supply: [{ "@type": "HowToSupply", name: "Example Supply" }],
    tool: [{ "@type": "HowToTool", name: "Example Tool" }],
    step: [
      {
        "@type": "HowToStep",
        text: "Example Step",
        image: "",
        url: "",
      },
    ],
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const addSupply = () => {
    setFormData({ ...formData, supplies: [...formData.supplies, ""] });
  };

  const addTool = () => {
    setFormData({ ...formData, tools: [...formData.tools, ""] });
  };

  const addStep = () => {
    setFormData({
      ...formData,
      steps: [...formData.steps, { text: "", imageUrl: "", url: "" }],
    });
  };

  const handleSupplyChange = (index, value) => {
    const updatedSupplies = formData.supplies.map((supply, i) =>
      i === index ? value : supply
    );
    setFormData({ ...formData, supplies: updatedSupplies });
  };

  const handleToolChange = (index, value) => {
    const updatedTools = formData.tools.map((tool, i) =>
      i === index ? value : tool
    );
    setFormData({ ...formData, tools: updatedTools });
  };

  const handleStepChange = (index, field, value) => {
    const updatedSteps = formData.steps.map((step, i) =>
      i === index ? { ...step, [field]: value } : step
    );
    setFormData({ ...formData, steps: updatedSteps });
  };

  const removeSupply = (index) => {
    setFormData({
      ...formData,
      supplies: formData.supplies.filter((_, i) => i !== index),
    });
  };

  const removeTool = (index) => {
    setFormData({
      ...formData,
      tools: formData.tools.filter((_, i) => i !== index),
    });
  };

  const removeStep = (index) => {
    setFormData({
      ...formData,
      steps: formData.steps.filter((_, i) => i !== index),
    });
  };

  const generateSchema = () => {
    return {
      "@context": "https://schema.org",
      "@type": "HowTo",
      name: formData.name,
      description: formData.description,
      totalTime: formData.totalTime,
      estimatedCost: {
        "@type": "MonetaryAmount",
        currency: formData.currency,
        value: formData.estimatedCost,
      },
      image: formData.imageUrl,
      supply: formData.supplies.map((supply) => ({
        "@type": "HowToSupply",
        name: supply,
      })),
      tool: formData.tools.map((tool) => ({
        "@type": "HowToTool",
        name: tool,
      })),
      step: formData.steps.map((step) => ({
        "@type": "HowToStep",
        text: step.text,
        image: step.imageUrl,
        url: step.url,
      })),
    };
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const updatedSchema = generateSchema();
    setSchema(updatedSchema);
    toast.success("How-To Schema generated successfully!");
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(JSON.stringify(schema, null, 2)).then(() => {
      toast.info("JSON-LD copied to clipboard!");
    });
  };
 const deleteSchema = () => {
    setSchema({
      "@context": "https://schema.org",
      "@type": "HowTo",
      name: "Example How-To",
      description: "This is an example description.",
      totalTime: "PT1H",
      estimatedCost: {
        "@type": "MonetaryAmount",
        currency: "USD",
        value: "10",
      },
      image: "https://example.com/image.jpg",
      supply: [{ "@type": "HowToSupply", name: "Example Supply" }],
      tool: [{ "@type": "HowToTool", name: "Example Tool" }],
      step: [
        {
          "@type": "HowToStep",
          text: "Example Step",
          image: "",
          url: "",
        },
      ],
    });
    toast.warning("Schema reset to dummy data!");
  };
  return (
    <div className="container mt-4">
      <ToastContainer />
      <h3 className="text-center mb-4">How-To Schema Generator</h3>
      <div className="row">
        {/* Form Section */}
        <div className="col-lg-6 mb-4">
          <div className="card shadow-sm p-4">
            <h5 className="card-title text-center mb-4">Enter How-To Details</h5>
            <form onSubmit={handleSubmit}>
              <div className="row mb-3">
                <div className="col-md-12">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Enter name"
                  />
                </div>
                <div className="col-md-12">
                  <label className="form-label">Description</label>
                  <textarea
                    className="form-control"
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    placeholder="Enter description"
                    rows="3"
                  ></textarea>
                </div>
              </div>
              {/* Total Time and Estimated Cost */}
        <div className="row mb-3">
          <div className="col-md-4">
            <label className="form-label">Total Time</label>
            <input
              type="text"
              className="form-control"
              name="totalTime"
              value={formData.totalTime}
              onChange={handleInputChange}
              placeholder="e.g., PT1H30M"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Estimated Cost</label>
            <input
              type="number"
              className="form-control"
              name="estimatedCost"
              value={formData.estimatedCost}
              onChange={handleInputChange}
              placeholder="Enter cost"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Currency</label>
            <select
              name="currency"
              className="form-select"
              value={formData.currency}
              onChange={handleInputChange}
            >
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="GBP">GBP</option>
            </select>
          </div>
        </div>

        {/* Image URL */}
        <div className="row mb-3">
          <div className="col-md-12">
            <label className="form-label">Image URL</label>
            <input
              type="text"
              className="form-control"
              name="imageUrl"
              value={formData.imageUrl}
              onChange={handleInputChange}
              placeholder="Enter image URL"
            />
          </div>
        </div>
              {/* Supplies */}
        <div className="mb-3">
          <label className="form-label">Supplies</label>
          {formData.supplies.map((supply, index) => (
            <div key={index} className="row align-items-end mb-2">
              <div className="col-md-10">
                <input
                  type="text"
                  className="form-control"
                  value={supply}
                  onChange={(e) => handleSupplyChange(index, e.target.value)}
                  placeholder="Enter supply"
                />
              </div>
              <div className="col-md-2 text-end">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => removeSupply(index)}
                >
                  ✖
                </button>
              </div>
            </div>
          ))}
          <button
            type="button"
            className="btn btn-primary ms-5"
            onClick={addSupply}
          >
            + Add Supply
          </button>
        </div>

        {/* Tools */}
        <div className="mb-3">
          <label className="form-label">Tools</label>
          {formData.tools.map((tool, index) => (
            <div key={index} className="row align-items-end mb-2">
              <div className="col-md-10">
                <input
                  type="text"
                  className="form-control"
                  value={tool}
                  onChange={(e) => handleToolChange(index, e.target.value)}
                  placeholder="Enter tool"
                />
              </div>
              <div className="col-md-2 text-end">
                <button
                  type="button"
                  className="btn btn-danger text-white"
                  onClick={() => removeTool(index)}
                >
                  ✖
                </button>
              </div>
            </div>
          ))}
          <button
            type="button"
         className="btn btn-primary ms-5"
            onClick={addTool}
          >
            + Add Tool
          </button>
        </div>

        {/* Steps */}
        <div className="mb-3">
          <label className="form-label">Steps</label>
          {formData.steps.map((step, index) => (
            <div key={index} className="row align-items-end mb-2">
              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Step Text"
                  value={step.text}
                  onChange={(e) =>
                    handleStepChange(index, "text", e.target.value)
                  }
                />
              </div>
              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Image URL"
                  value={step.imageUrl}
                  onChange={(e) =>
                    handleStepChange(index, "imageUrl", e.target.value)
                  }
                />
              </div>
              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control"
                  placeholder="URL"
                  value={step.url}
                  onChange={(e) => handleStepChange(index, "url", e.target.value)}
                />
              </div>
            </div>
          ))}
          <button
            type="button"
           className="btn btn-primary ms-5"
            onClick={addStep}
          >
            + Add Step
          </button>
        </div>

              {/* Submit Button */}
              <button type="submit" className="btn btn-success w-100">
                Generate Schema
              </button>
            </form>
          </div>
        </div>

        {/* JSON-LD Preview Section */}
        <div className="col-lg-6">
          <div className="card shadow-sm p-4">
            <h5 className="card-title text-center mb-4">Generated JSON-LD</h5>
            <div className="d-flex justify-content-center align-items-center mb-3 mt-3">
  <button className="btn btn-primary me-2" onClick={copyToClipboard}>
    Copy
  </button>
  <button className="btn btn-danger me-2" onClick={deleteSchema}>
    Reset
  </button>
  <button className="btn btn-info me-2">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://developers.google.com/search/docs/appearance/structured-data"
    >
      Validate
    </a>
  </button>
  <button className="btn btn-success">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://search.google.com/test/rich-results"
    >
      Test
    </a>
  </button>
</div>
            <div className="bg-light p-3 rounded border">
              <JSONPretty id="json-pretty" data={schema}></JSONPretty>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowToSchemaForm;
